export default __webpack_public_path__ + "static/media/punto-originario-default-typ.cd1f75ca.svg";